/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Page-level tabs: an underline on the chosen tab, over a divider line (Members, Programming).
 */
export const LINE_TABS_LIST = "h-auto gap-0 p-0";
export const LINE_TAB_TRIGGER =
  "h-auto flex-none rounded-none border-0 border-b-2 border-transparent bg-transparent px-3 pb-2 pt-1 data-[state=active]:border-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none";
